import React from "react";
import styled from "styled-components";

const Header = styled.header`
    display: flex;
    align-items: flex-end;

    &:first-child {
        padding-top: 3em;
    }

    .single-letter-back {
        color: #e0e0e0;
        font-weight: 600;
        z-index: 0;
        font-size: 6.25rem;
    }

    h2 {
        font-size: 2.7rem;
        margin-left: -.5em;
        line-height: 70px;
        z-index: 1;
        color: #004181;
    }

    @media (max-width: 768px) {
        &:first-child {
            padding-top: 0em;
        }

        h2 {
            font-size: 1.9rem;
            line-height: 30px;
            margin-left: 0;
        }
        
        .single-letter-back {
            display: none;
        }
    }
`

const TitleWithFirstLetter = ({title, style}) => {
    return (
        <Header style={{...style}}>
            <span className="single-letter-back">{title.split("")[0]}</span>
            <h2>{title}</h2>
        </Header>
    )
}

export default TitleWithFirstLetter;